"use client";
//? Library Imports ------------------------------------------------------------>
import Image from "next/image";
import { useSelector, useDispatch } from "react-redux";
import { useRouter } from "next/navigation";
import { useCallback, useEffect, useState } from "react";
import { Col, Row, Space, Skeleton, Typography } from "antd";

//? Assets --------------------------------------------------------------------->
import { ArrowLeftOutlined } from "@ant-design/icons";
import Coins from "../../../../../assets/images/AccountsPage/Coins.svg";
import MySLogo from "../../../../../assets/images/logos/MySWalletLogo.svg";

//? Modules -------------------------------------------------------------------->
// import WishlistCard from "./WishlistCard/WishlistCard";
import AccountStatus from "@/functions/Cookies/Cookies";
import DynamicButton from "@/components/shared/Buttons/DynamicButton/DynamicButton";
import { customerLogout } from "@/functions/Cookies/Cookies";

//? Redux Reducers ------------------------------------------------------------->
import { logoutReducer } from "@/redux/Slices/accountSlice";
//? Library Constants ---------------------------------------------------------->
const { Text } = Typography;
const index = 2;

export default function Wallet() {
  const router = useRouter();
  const dispatch = useDispatch();
  const {
    loggedIn,
    comverse_customer_id,
    comverse_customer_email,
    comverse_customer_token,
  } = AccountStatus();

  //? Redux States --------------------------------------------------------------->
  const defaultCurrency = useSelector(
    (state) => state.multiLocation.defaultCurrency
  );

  const [WalletPoints, setWalletPoints] = useState({});
  const [WalletHistory, setWalletHistory] = useState({});

  const fetchWalletPoints = useCallback(async () => {
    try {
      const headers = {
        "Content-Type": "application/json",
      };
      if (comverse_customer_token) {
        headers.Authorization = comverse_customer_token;
      }

      const payload = {
        method: "GET",
        headers: headers,
      };

      const res = await fetch(
        process.env.NEXT_PUBLIC_BACKEND + "/storefront/get_wallet_balance",
        payload
      );

      const data = await res.json();

      if (!res.ok) {
        if (data?.detail === "Invalid auth token") {
          customerLogout();
          dispatch(logoutReducer());
          router.push("/login");
        }
        //logout here

        throw new Error("Api Failed!");
      }

      setWalletPoints(data);
      return data;
    } catch (error) {
      console.error("Error fetching data:", error.message);
      return null;
    }
  }, [comverse_customer_token]);

  const fetchWalletHistory = useCallback(async () => {
    try {
      const headers = {
        "Content-Type": "application/json",
      };
      if (comverse_customer_token) {
        headers.Authorization = comverse_customer_token;
      }

      const payload = {
        method: "GET",
        headers: headers,
      };

      const res = await fetch(
        process.env.NEXT_PUBLIC_BACKEND + "/storefront/get_wallet_history",
        payload
      );

      const data = await res.json();

      if (!res.ok) {
        throw new Error("Api Failed!");
      }

      setWalletHistory(data);
      return data;
    } catch (error) {
      console.error("Error fetching data:", error.message);
      return null;
    }
  }, [comverse_customer_token]);

  useEffect(() => {
    if (comverse_customer_token) {
      fetchWalletPoints();
    }
  }, [comverse_customer_token, fetchWalletPoints]);

  useEffect(() => {
    if (comverse_customer_token) {
      fetchWalletHistory();
    }
  }, [comverse_customer_token, fetchWalletHistory]);

  return (
    <Col className="WalletHistory">
      <Col span={24} className="padding10">
        <Text className="font14Bold poppinsMedium">My Wallet</Text>
      </Col>

      <Col className="">
        <Row className="gap10">
          <Col span={24} className="padding10">
            <Col flex="0 0 auto" className="walletCard">
              <Space className="flexBetween width100">
                <Space className="flexBetween width100 gap30">
                  <Image
                    src={MySLogo}
                    width="38px"
                    height="auto"
                    alt="MySLogo"
                    preview={false}
                  />
                  <Space direction="vertical" className="gap10">
                    <Text className="font16" style={{ color: "#FFFFFF" }}>
                      Total Balance
                    </Text>
                    <Text className="font18Bold" style={{ color: "#FFFFFF" }}>
                      {WalletPoints?.wallet_points
                        ? WalletPoints?.wallet_points
                        : 0}
                      &nbsp;
                      {defaultCurrency}
                    </Text>
                  </Space>
                </Space>
                <Image
                  src={Coins}
                  width="100%"
                  height="auto"
                  alt="Coins"
                  preview={false}
                />
              </Space>
            </Col>
          </Col>

          {WalletHistory?.results?.length > 0 ? (
            <Col span={24} className="RewardTable marginTop25 backgroundLight">
              <Row wrap={false}>
                <Col flex="33%" className="font12Bold flexCenter">
                  <Text
                    className="font12 poppinsMedium"
                    style={{ color: "#5A7184" }}
                  >
                    No
                  </Text>
                </Col>
                <Col flex="33%" className="font12Bold flexCenter">
                  <Text
                    className="font12 poppinsMedium"
                    style={{ color: "#5A7184" }}
                  >
                    Date
                  </Text>
                </Col>
                <Col flex="33%" className="font12Bold flexCenter">
                  <Text
                    className="font12 poppinsMedium"
                    style={{ color: "#5A7184" }}
                  >
                    Added/Deducted
                  </Text>
                </Col>
              </Row>

              <Col span={24} className="marginTop10">
                {WalletHistory?.results?.map((result, index) => {
                  return (
                    <Row
                      key={index}
                      wrap={false}
                      className={
                        index % 2 === 0 ? "tableRow rowColor" : "tableRow"
                      }
                    >
                      <Col flex="33%" className="flexCenter">
                        <Text className="font12" style={{ color: "#333333" }}>
                          {result?.id}
                        </Text>
                      </Col>
                      <Col flex="33%" className="flexCenter">
                        <Text className="font12" style={{ color: "#333333" }}>
                          {result?.created_at ? result?.created_at : "N/A"}
                        </Text>
                      </Col>
                      <Col flex="33%" className="flexCenter flexColumn">
                        <Space direction="vertical" className="gap0 flexCenter">
                          <Text className="font12" style={{ color: "#333333" }}>
                            {defaultCurrency}&nbsp;
                            {result?.value ? result?.value : 0}
                          </Text>
                        </Space>
                      </Col>
                    </Row>
                  );
                })}

                {
                  WalletHistory?.next &&
                  <DynamicButton
                    type="primary"
                    name="Load More"
                    property="danger"
                    className="primary_btn_outline loadMore"
                  // function={() => fetchSimilarProducts()}
                  />
                }
              </Col>
            </Col>
          ) : null}
        </Row>
      </Col>
    </Col>
  );
}
